import { render, staticRenderFns } from "./ScoringMultipliers.vue?vue&type=template&id=55672b0f"
import script from "./ScoringMultipliers.vue?vue&type=script&lang=js"
export * from "./ScoringMultipliers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports